import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { useClientApiKeys } from "@hooks/useClientSettings";
import { appVersion, envMode } from "@settings";
import { useEffect, useRef, useMemo } from "react";

export const DataDogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { dataDog } = useClientApiKeys();

  const hasInitialized = useRef(false);
  const plugin = useMemo(() => reactPlugin({ router: true }), []);

  useEffect(() => {
    const { applicationId, clientToken, serviceName } = dataDog ?? {};
    console.log("Initializing Datadog RUM with settings:", {
      dataDog,
    });

    if (
      hasInitialized.current ||
      !applicationId ||
      !clientToken ||
      !serviceName
    ) {
      return;
    }

    hasInitialized.current = true;
    datadogRum.init({
      applicationId,
      clientToken,
      site: "datadoghq.com",
      service: serviceName,
      env: envMode,
      version: appVersion,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 50,
      defaultPrivacyLevel: "mask-user-input",
      plugins: [plugin],
    });
    datadogRum.startSessionReplayRecording();
    console.log("Datadog RUM initialized");
  }, [dataDog, plugin]);

  return <>{children}</>;
};
